module.exports = __webpack_public_path__ + "static/media/tv-questions.fea50df3.csv";